export const scorers: Record<number, string> = {
  1351: "Unique Humanity Score",
}
